import { TextField } from "@mui/material";

export const DatePicker = ({ label, date, setDate, errMsg, minDate }) => {
  const borderColor = errMsg ? "#dc354599" : "#ddd";

  return (
    <div className="d-flex align-items-center gap-2">
      <span className="text-12 text-muted">{label}</span>
      <TextField
        size="small"
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        sx={{
          width: "10.5rem",
          "& .MuiOutlinedInput-root": {
            // backgroundColor: "#fff", // Default background
            "&:hover": {
              backgroundColor: "#f5f5f5", // Light background on hover
            },
            "& fieldset": {
              borderColor: borderColor,
            },
            "&:hover fieldset": {
              borderColor: borderColor,
            },
            "&.Mui-focused fieldset": {
              borderColor: borderColor,
            },
          },
          "& input": {
            boxShadow: "none !important",
            outline: "none",
          },
        }}
        slotProps={{
          input: {
            inputProps: {
              min: minDate,
            },
            sx: {
              fontSize: "0.9rem",
              color: date ? "#303030" : "#808080", // dark if selected, light gray if empty
            },
          },
        }}
      />
      <p className="m-0 text-12 text-center text-danger" style={{height: "1rem"}}>{errMsg}</p>
    </div>
  );
};
